export const enum LocalStorageKeyEnum {
  STATE = 'rmesse-platform-state',
  TOKEN = 'rmesse-platform-token',
  SESSION_ID = 'rmesse-platform-sessionId',
  LOGIN_TYPE = 'login-type',
}

export const removeLocalStorageItem = (key: LocalStorageKeyEnum) => {
  localStorage.removeItem(key);
};

export const getLocalStorageItem = (key: LocalStorageKeyEnum) => {
  return localStorage.getItem(key);
};

export const setLocalStorageItem = (
  key: LocalStorageKeyEnum,
  value: string,
) => {
  return localStorage.setItem(key, value);
};
